import { useEffect, useState } from "react";

export default function Speedometer({ onTrack }) {
  const [speed, setSpeed] = useState(0);

  useEffect(() => {
    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const { latitude, longitude, speed } = pos.coords;
        const speedKph = speed ? (speed * 3.6).toFixed(1) : 0;
        setSpeed(speedKph);
        onTrack({ lat: latitude, lon: longitude });
      },
      (err) => console.error(err),
      { enableHighAccuracy: true, maximumAge: 0, timeout: 5000 }
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, [onTrack]);

  return (
    <div className="text-center">
      <div className="text-5xl font-bold text-green-500">{speed} km/h</div>
      <div className="text-sm text-gray-400">Current Speed</div>
    </div>
  );
}
